import React from 'react';
import './CardInfoBox.css';

export interface CardInfoBoxProps {
  /** Box title */
  title?: string;
  /** Content to display inside the box */
  children: React.ReactNode;
  /** Additional CSS class */
  className?: string;
}

/**
 * Card info box component for displaying metadata about a flashcard.
 * Used to show selection reason, deck, source file, etc.
 */
export const CardInfoBox: React.FC<CardInfoBoxProps> = ({
  title = 'Card Info',
  children,
  className = '',
}) => {
  return (
    <div className={`stc-card-info-box ${className}`}>
      <div className="stc-card-info-box__title">{title}</div>
      <div className="stc-card-info-box__content">{children}</div>
    </div>
  );
};
